var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',[_c('PageHeader',{attrs:{"add":{icon: 'bx bx-add-to-queue bx-tada', title: 'general.new', link: 'sale-add'},"title":_vm.$t('menuitems.sale.text')}}),_c('List',{attrs:{"dataList":_vm.saleData,"more":{
          sub: [
          {name: 'general.print', icon:'fa fa-print', link: 'report-transfer-sale-print', column: 'id'} ]
        },"filter":{
          search: ['sale_transfers.sale', 'sale_transfers.from_name', 'sale_transfers.to_name', 'sale_transfers.property'],
          dropdown: [{
            title: 'property.project',
            field: 'properties.project_id',
            data: this.projectData.data,
            method: function (event) { return _vm.projectChanged(event); },
            default: 1,
            width: 2
          }, {
            title: 'property.group',
            field: 'properties.property_group_id',
            data: this.groupData.data,
          }, {
            title: 'property.floor',
            field: 'properties.project_floor_id',
            show: 'number',
            data: this.floorData.data,
          }],
          date: {
            title: 'general.date',
            field: 'sales.sale_date'
          }
        },"updating":_vm.fetchingStats,"navigate":_vm.pageNavigate,"formats":[
          {name: 'status', color: true}, 
          {name: 'currency_en'}, 
          {name: 'for_date', type: 'date'}, 
          {name: 'expire_date', type: 'date'},
          {name: 'sell_price', type: 'currency', sign: '$'} ],"fields":[ 
          ("code: " + (_vm.$t('sale.code'))), 
          ("property: " + (_vm.$t('property.text'))), 
          "from_name: ឈ្មោះអតិថិជនចាស់", 
          "to_name: ឈ្មោះអតិថិជនថ្មី", 
          ("for_date: " + (_vm.$t('general.date'))), 
          ("sell_price: " + (_vm.$t('booking.price'))),
          "fee: តម្លៃសេវាកម្ម",
          "status: ស្ថានភាព" ]},on:{"more":_vm.moreClick}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }